export default "__VITE_ASSET__Dckglrs8__"